export class ImportBeneficiaryResult {
  data: [{
    Message: string
  }] | []

  public getMessages(): string[] {
    return this.data.map((item) => item.Message);
  }

  constructor(data: [{ Message: string }] | []) {
    this.data = data;
  }
}
